import Add16 from '@carbon/icons-react/es/add/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';

const Wrapper = styled.div`
  padding-left: var(--spacing-06);
`;

interface Props {
  addUsers: () => void;
  addTeams: () => void;
  readOnly: boolean;
}
export const AssignUserOrTeam: FC<Props> = ({
  addUsers,
  addTeams,
  readOnly,
}) => {
  return (
    <Wrapper>
      <Button
        type="link"
        icon={<Add16 />}
        onClick={addTeams}
        disabled={readOnly}
      >
        <FormattedMessage id="resource_management.actions.add_placeholder_to_project" />
      </Button>
      <Button
        type="link"
        icon={<Add16 />}
        onClick={addUsers}
        disabled={readOnly}
      >
        <FormattedMessage id="resource_management.actions.add_user_to_project" />
      </Button>
    </Wrapper>
  );
};
